import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getCustomer } from '../../../api';

export const coreCustomersByIdGetSlice = createGetAsyncSlice({
	name: 'CoreCustomersById',
	receive: true,
	request: true,
	requestHandler: getCustomer,
	retainDataOnRequest: true
});
